import classNames from 'classnames'

import StepCardComponent from './StepCard'
import style from './style.scss'

type Card = {
  contentText: string
  headerText: string
}

type Props = {
  className?: string
  cards: Card[]
}

function AffiliateStepsCards(props: Props) {
  const { cards, className } = props
  return (
    <div className={classNames(style.wrapper, className)}>
      {cards.map((card, index) => (
        <StepCardComponent key={card.headerText} index={index + 1} {...card} />
      ))}
    </div>
  )
}

export default AffiliateStepsCards
